export const FormCard = ({ title, children, width }) => {
    const cardWidth = width || "w-full sm:w-72"

    return (
        <div className="flex h-18 sm:h-10 text-sm">
            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                <div className="min-w-48">
                    <span>{ title }</span>
                </div>
                <div className="px-4 w-2 hidden sm:block">
                    <span>{title !== '' ? ':' : ''}</span>
                </div>
                <div className={` ${cardWidth}`}>
                    { children }
                </div>
            </div>
        </div>
    )
}